import {
  ChangeDetectionStrategy,
  Component,
  input,
  ViewEncapsulation,
} from '@angular/core';

@Component({
  selector: 'fz-odometer-number',
  standalone: true,
  templateUrl: './odometer-number.html',
  styleUrls: ['./odometer-number.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'fz-odometer-number',
  },
})
export class OdometerNumber {
  number = input<string | number>();
}
